import React, { createContext, useContext } from 'react';
import useFilter from '@/finsight/application/League/Table/filters/useFilter';
import { ILeaguePeriodFilters } from '@/finsight/application/League/interfaces';

type LeagueTableFiltersContextType = ReturnType<typeof useFilter>;

export const LeagueTableFiltersContext = createContext<LeagueTableFiltersContextType>(null);

export const useLeagueTableFiltersContext = () => {
  const context = useContext(LeagueTableFiltersContext);

  if (!context) {
    throw new Error('useLeagueTableFiltersContext must be used within the LeagueTableFiltersContext');
  }

  return context;
};

interface IProps {
  searchText: string,
  ttmFilterInitState: ILeaguePeriodFilters,
  children: React.ReactNode,
}

const LeagueTableFilterContextProvider = ({
  searchText,
  ttmFilterInitState,
  children,
}:IProps) => (
  <LeagueTableFiltersContext.Provider
    value={ useFilter({ searchText, ttmFilterInitState }) }
  >
    { children }
  </LeagueTableFiltersContext.Provider>
);

export default LeagueTableFilterContextProvider;
